module.exports = "/assets/bundles/edca7d5bc099fad997b0cf55f2661d4b.svg";